import baseURL from "../api"
import { leadCadastrarPayload } from "../../interfaces/leads"

export function novoLead (payload: leadCadastrarPayload ) {
    return baseURL.post ('/leads', payload)
}